module.exports = __webpack_public_path__ + "img/macbook.9455afcf.png";